import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {
  DialogWidth,
  PermissionsService,
  REPORT_MODAL_TYPE,
  RefModelNode,
  Refmodel,
  SessionService
} from '@q9elements/ui-kit/common';
import {ReportModalComponent} from '@q9elements/ui-kit/components';
import {ICustomView} from '../../editor-interface/models/custom-view.interface';

@Injectable({
  providedIn: 'root'
})
export class ReportDialogService {
  constructor(
    private dialog: MatDialog,
    private sessionService: SessionService,
    private permissionsService: PermissionsService
  ) {}

  public openReportDialog(
    modalType: REPORT_MODAL_TYPE,
    refModelNode: RefModelNode,
    refModel?: Refmodel,
    rootData?: any,
    customView?: ICustomView | string
  ): void {
    const userInTeam = this.sessionService.user()!.userInTeam!;
    const currentTeam = {
      _id: this.sessionService.teamId(),
      name: userInTeam.team.name,
      planType: userInTeam.team.plan.type,
      teamIndex: this.sessionService.teamIndex(),
      trialExpired: !this.permissionsService.isProActive()
    };
    const anchorTarget = '_blank';

    this.dialog.open(ReportModalComponent, {
      width: DialogWidth.LG_XL,
      data: {
        currentTeam,
        modalType: modalType,
        generalReportType: 'referenceModel',
        metadata: {
          refModelNode,
          refModel,
          rootData,
          customView
        },
        anchorTarget
      }
    });
  }
}
